// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// jquery_ujs is loaded via Sprockets — do NOT load @rails/ujs here (causes dual-UJS error)
require("@rails/activestorage").start()
require("../channels")

// Bootstrap dependencies are loaded via Sprockets (application.js.erb)
// Do NOT import jQuery here - it overwrites window.$ and breaks Sprockets plugins
import 'popper.js'

// CSS is fully handled by Sprockets (app/assets/stylesheets/)
// Do NOT import CSS here - it causes duplicate Bootstrap and breaks design

// Import custom JavaScript
import '../src/custom'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Initialize Bootstrap components when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Pause the similar-artists scroller on hover and touch (mobile)
  try {
    var containers = document.querySelectorAll('.scroller-container');
    containers.forEach(function(container) {
      var wrapper = container.querySelector('.scroller-wrapper');
      if (!wrapper) return;

      var pause = function() { wrapper.classList.add('is-paused'); };
      var resume = function() { wrapper.classList.remove('is-paused'); };

      // Desktop pointer
      container.addEventListener('mouseenter', pause);
      container.addEventListener('mouseleave', resume);

      // Touch devices: pause on touch, resume shortly after finger lifts
      container.addEventListener('touchstart', pause, { passive: true });
      container.addEventListener('touchend', function() { setTimeout(resume, 800); }, { passive: true });
      container.addEventListener('touchcancel', resume, { passive: true });
    });
  } catch (e) {
    console.warn('Scroller pause handler failed:', e);
  }
})
